import * as localForage from 'localforage';

import { createStore } from '@ngneat/elf';
import { withActiveId, withActiveIds, withEntities } from '@ngneat/elf-entities';
import {
    createRequestsCacheOperator, createRequestsStatusOperator, initializeAsPending,
    withRequestsCache, withRequestsStatus
} from '@ngneat/elf-requests';
import { persistState } from '@shared/third-party/persist-state/persist-state';

import { ReservationLaunch } from './active-reservation.interface';

export const store = createStore(
	{ name: 'activeReservation' },
	withEntities<ReservationLaunch, 'reservation_id'>({ idKey: 'reservation_id' }),
	withRequestsStatus<`activeReservations` | `activeReservation-${string}`>(
		initializeAsPending('activeReservations')
	),
	withRequestsCache<`activeReservations` | `activeReservation-${string}`>(),
	withActiveId(),
	withActiveIds()
);
export const trackActiveReservationRequestsStatus = createRequestsStatusOperator(store);
export const persist = persistState(store, {
	key: 'activeReservations',
	storage: localForage,
});
export const skipWhileActiveReservationCached = createRequestsCacheOperator(store);
